import { Link } from 'react-router-dom';
import './search-results.scss';
import { useParams } from 'react-router';

function SearchResults({
    searchResults,
    open
} : {
    searchResults: any[],
    open: boolean
}) {
    const params: any = useParams();
    
    return (
        <div id="search-results" className={open ? 'open' : ''}>
            {!searchResults.length && <i>No results found</i>}
            {searchResults.filter((x: any) => x.TypeId === 1).length ? <p>Boards</p> : ''}
            {searchResults.filter((x: any) => x.TypeId === 1).map((result: any) => result.Data).map((data: any, i: number) => {
                return (
                    <Link to={`/client/${params.clientId}/board/${data.Id}`} className="result" key={i}>
                        <i className="fal fa-chalkboard"></i>
                        <p>{data.Description}</p>
                    </Link>
                )
            })}
            {searchResults.filter((x: any) => x.TypeId === 2).length ? <p>Tickets</p> : ''}
            {searchResults.filter((x: any) => x.TypeId === 2).map((result: any) => result.Data).map((data: any, i: number) => {
                return (
                    <Link to={`/client/${params.clientId}/board/${data.BoardId}?ticketId=${data.Id}`} className="result" key={i}>
                        <i className="fal fa-pager"></i>
                        <p>{data.Heading}</p>
                    </Link>
                )
            })}
        </div>
    )
}

export default SearchResults;